import request from '@/utils/request'

export function getAppListAll(data) {
  return request({
    url: '/user/getAppListAll',
    method: 'post',
    data
  })
}

export function deleteApp(data) {
  return request({
    url: '/user/deleteApp',
    method: 'post',
    data
  })
}

export function saveApp(data) {
  return request({
    url: '/user/saveApp',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js